import type { FC } from 'react';
import { useConditionsFlows } from '../../facebook';
import { observer } from 'mobx-react-lite';
import useRulePageMode from '../../hooks/useRulePageMode';
import useCurrentTasksFormStore from '../../hooks/useCurrentTasksFormStore';
import type { OptionValue } from '../../../../types/shared';
import { RuleEditAutoCompleteStyled } from '../RuleEditComponents';
import type { ConditionVariantProps } from '../../types';

export const FlowsMetrics: FC<ConditionVariantProps> = observer(
  ({ indexCondition, indexTask, field, indexVariant }) => {
    const { isRead } = useRulePageMode();
    const isVariant = typeof indexVariant === 'number';
    const disabled = isRead;
    const tasksFormStore = useCurrentTasksFormStore();
    const handleChangeFlow = (value: OptionValue) => {
      tasksFormStore.setConditionMetric(indexTask, indexCondition, field, value as string);
    };

    const { data: conditionsConstants } = useConditionsFlows({
      config: { select: (data) => data.map(({ name, id }) => ({ value: id, label: name })) },
    });

    const value = isVariant
      ? tasksFormStore.getVariantOnTaskCondition(indexTask, indexVariant, indexCondition)?.[field]
      : tasksFormStore.getConditionMetric(indexTask, indexCondition)?.[field];

    return (
      <RuleEditAutoCompleteStyled
        allSelectable={false}
        value={value}
        onChange={handleChangeFlow}
        id={`Autocomplete-${field}-${indexTask}-${indexCondition}`}
        options={conditionsConstants ?? []}
        InputProps={{
          ...(tasksFormStore?.propsRestriction ?? null),
          disabled: disabled,
        }}
      />
    );
  }
);

export default FlowsMetrics;
